import React from "react";
import { Fragment } from "react";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { NaviagateIcon } from "../../../assets/icons/index";
import { Link } from "react-router";

interface passedProps {
  items: Array<IBreadcrumb>;
  state?: any;
}

function Breadcrumb(props: passedProps) {
  const { items } = props;
  return (
    <Fragment>
      <nav className="flex border-t pt-2.5 mt-2" aria-label="Breadcrumb">
        <ol className="flex items-center space-x-2">
          {items.map((item, i) => {
            return (
              <li key={i}>
                <div className="flex items-center">
                  {i > 0 && <NaviagateIcon />}
                  {item.url !== "" ? (
                    <Link
                      to={item.url}
                      state={item.state}
                      className="text-sm font-medium text-gray-500 hover:text-gray-700"
                    >
                      {item.objectId ? item.objectId : item.name}
                    </Link>
                  ) : (
                    <span className="text-sm font-medium text-gray-500 hover:text-gray-700">
                      {item.objectId ? item.objectId : item.name}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      </nav>
    </Fragment>
  );
}

export default Breadcrumb;
